export default function useGetHoursMinutes(time) {

  const [hours, minutes] = [Math.floor(time / 60), time % 60];

  return {
    hours: hours,
    minutes: minutes
  }
}